module.exports = __webpack_public_path__ + "img/corporateCulture4.3bfd7dd8.png";